export const getSnapshotForYear = async (slug, yearId) => {
  const response = await fetch(`/api/v1/entities/${yearId}/${slug}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
  }
  const res = await response.json();
  return res.relationships[slug];
};

export const getSnapshotForYearNew = async (slug, yearId, year = "") => {
  const response = await fetch(`/fortune-api/rankings/${yearId}/${slug}/${year}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
  }
  const res = await response.json();
  return res || [];
};

export const fetchEntityData = async (slug, yearId) => {
  try {
    let snapshotData = await getSnapshotForYear(slug, yearId);
    let currentRankColumn = "current-rank";
    if (slug == "emergingcompanies-snapshot-year") {
      currentRankColumn = "rank";
      snapshotData = snapshotData.map((item) => ({ ...item, revenue: item.noi }));
    }
    return snapshotData?.sort((a, b) => a[currentRankColumn] - b[currentRankColumn]).slice(0, 5) || [];
  } catch (error) {
    console.error(`Error fetching entity data: ${error.message}`);
    return [];
  }
};

export const fetchEntityDataNew = async (slug, yearId, year = "") => {
  try {
    let snapshotData = await getSnapshotForYearNew(slug, yearId, year);
    return snapshotData || [];
  } catch (error) {
    console.error(`Error fetching entity data: ${error.message}`);
    return [];
  }
};

export const fetchBSchoolsData = async (year, limit) => {
  try {
    const response = await fetch(
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${year}-bschool.json`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.snapshots.slice(0, 5);
  } catch (error) {
    console.error(`Error fetching entity data: ${error.message}`);
    return [];
  }
};
